import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { BonusSettlementCustomerDetail } from '../models/bonus-settlement-customer-detail';
import { BonusSettlementCustomerDetailsSidebar } from '../models/bonus-settlement-customer-details-sidebar';
import {
    getBonusSettlementCustomerDetailSidebar,
    getBonusSettlementCustomerDetails,
    resetBonusSettlementsCustomerDetailState,
} from './bonus-settlements-customer-detail-actions';

export interface BonusSettlementsCustomerDetailReducerState {
    bonusSettlementCustomerDetail: PaginatedResponse<BonusSettlementCustomerDetail>;
    sidebarDetails?: BonusSettlementCustomerDetailsSidebar;
    requesting: boolean;
}

const initialState: BonusSettlementsCustomerDetailReducerState = {
    bonusSettlementCustomerDetail: {
        page: 0,
        limit: 0,
        total: 0,
        items: [],
    },
    sidebarDetails: undefined,
    requesting: false,
};

export const bonusSettlementsCustomerDetailReducer = createReducer(initialState, builder =>
    builder

        .addCase(getBonusSettlementCustomerDetails.pending, state => {
            state.requesting = true;
        })

        .addCase(getBonusSettlementCustomerDetails.fulfilled, (state, action) => {
            if (action.payload) {
                state.bonusSettlementCustomerDetail = action.payload;
            }

            state.requesting = false;
        })

        .addCase(getBonusSettlementCustomerDetailSidebar.pending, state => {
            state.requesting = true;
        })

        .addCase(getBonusSettlementCustomerDetailSidebar.fulfilled, (state, action) => {
            if (action.payload) {
                state.sidebarDetails = action.payload;
            }

            state.requesting = false;
        })

        .addCase(resetBonusSettlementsCustomerDetailState, state => {
            state.bonusSettlementCustomerDetail = initialState.bonusSettlementCustomerDetail;
            state.sidebarDetails = initialState.sidebarDetails;
        })
);
